// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1FmOU","notes":"Notes_notes__1Wniv"};